module.exports = __webpack_public_path__ + "static/media/VIDA EN BALANCE.7d1fe8b5.jpg";